import { render, staticRenderFns } from "./ReservationsActPop.vue?vue&type=template&id=65805a18&scoped=true&"
import script from "./ReservationsActPop.vue?vue&type=script&lang=js&"
export * from "./ReservationsActPop.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsActPop.vue?vue&type=style&index=0&id=65805a18&lang=scss&scoped=true&"
import style1 from "./ReservationsActPop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65805a18",
  null
  
)

export default component.exports